import packageInfo from '../../package.json';

export const environment = {
  production: true,
  environment: 'staging',
  electron_schema: 'bisualintranet',
  laravel_url: 'https://testapi.bisual.net',
  angular_url: 'https://test.intranet.bisual.net',
  auth_url: 'https://testauth.bisual.net',
  oauth_client_id: '01a0c4a4-73f3-7346-bd5e-3805e27e2f6c',
  oauth_personal_access_client_id: '01a0c4b5-c747-7305-864b-5727fa1b9114',
  google_maps_api_key: 'AIzaSyBKt2NWBiPFZPdnvzHT-NI3Cp9R3muMILI',
  tiny_api_keys: [
    'n2e99sz8a34zy9lgpjkkuyr19mcm7ufwh6q02k0o6a2zrq9l', // developers.bisual@gmail.com
    'lt1rkkdp9iq039tqtgxk9b3lcepg8sxuq0x27gwn42o7w5nh', // consultoria.bisual@gmail.com
    '53m6sjdr3ns0zq7a57saj126abdcngq0kkk44ebkd7molrjc', // agencia.bisual@gmail.com
    'mhuo3av0ffa258l5ba81nbzowgakyl8cai8aqypedssllg9z', // polribas14@gmail.com
  ],
  version: packageInfo.version,
  pusher: {
    app_id: '1930554',
    key: 'c0c12f0dfad5e07b919c',
    secret: '5fb70771d10c02d4b1ba',
    cluster: 'eu',
  },
};
